module.exports = __webpack_public_path__ + "static/media/apng_nightmare.468d638c.png";